import APIBase from "./apiBase";
import { Challenge } from "./challengeLib";

export interface Address {
  name: string;
  address: string;
  local: string;
  domain: string;
}
export interface MessageHeader {
  id: string;
  name: string;
  value: string;
}
export interface Message {
  id: string;
  timestamp: string;
  labels: string[];
  subject: string;
  to: Address[];
  cc: Address[];
  bcc: Address[];
  from: Address[];
  headers?: MessageHeader[];
  challenge: Challenge;
  messageAction?: {
    mode: "applied" | "pending" | "failed";
    actionType: "allow" | "blocked" | "no action" | "filter" | "challenge";
  };
}

export interface RuleEvalResponse {
  duration: number;
  rulesInScope: RulesInScope[];
  matchesInPrecedenceOrder: MatchesInPrecedenceOrder[];
  finalAction: string;
}

export interface MatchesInPrecedenceOrder {
  ruleScope: string;
  ruleId: string;
  ruleAction: string;
  rulePatternTarget: string;
  rulePatternValue: string;
  messageValue: string;
  rulePrecedence: number;
}

export interface RulesInScope {
  patterns: Pattern[];
  id: string;
  scopeTargetType: string;
  scopeTargetId: null | string;
  ruleAction: string;
  status: string;
}

export interface Pattern {
  value: string;
  target: string;
}

export interface MessagesPageResponse {
  inboxId: string;
  messages: Message[];
  page: number;
  totalCount: number;
}

export const get = async (
  id: string,
  includeHeaders: boolean = true
): Promise<Message> => {
  const { data } = await APIBase.get<Message>(`/messages/${id}`, {
    params: { headers: includeHeaders },
  });
  return data;
};

export const getPageForInbox = async (
  inboxId: string,
  includeHeaders: boolean = false,
  filter?: string,
  page: number = 0
): Promise<MessagesPageResponse> => {
  const params: {
    inboxId: string;
    headers?: boolean;
    filter?: string;
    page: number;
  } = { inboxId, page: page + 1 }; // Convert 0-indexed to 1-indexed for API
  if (includeHeaders) {
    params.headers = true;
  }
  if (filter && filter.trim()) {
    params.filter = filter.trim();
  }

  const { data } = await APIBase.get<MessagesPageResponse>(`/messages`, {
    params,
  });
  return data;
};

export const testRules = async (messageId: string) => {
  console.log(`Testing ${messageId}`);
  const { data } = await APIBase.post(`/messages/${messageId}/testRules`);
  return data as RuleEvalResponse;
};

export const moveToInboxAndTagAsDonated = async (messageId: string) => {
  const { data } = await APIBase.post(
    `/messages/${messageId}/moveToInboxAndTagAsDonated`
  );
  return data;
};

export const runCobutlerFiltering = async (
  messageId: string,
  filteringMode: "simulating" | "filtering"
) => {
  const { data } = await APIBase.post(
    `/messages/${messageId}/runCobutlerFiltering`,
    null,
    {
      params: { filteringMode },
    }
  );
  return data;
};
